﻿import { Injectable } from "@angular/core";
import { EncryptionModel } from '../model/encryption.model';
var cryptoJS = require("crypto-js");



@Injectable()
export class EncryptionService {

    constructor() {
    }

    EncryptionSrvc(_cryptoModel: EncryptionModel) {
        var ciphertext = cryptoJS.AES.encrypt(_cryptoModel.valueString, _cryptoModel.vEncVector);
        var key = cryptoJS.enc.Utf8.parse(_cryptoModel.key);
        var iv = cryptoJS.enc.Utf8.parse(_cryptoModel.vEncVector);
        var encValue = cryptoJS.AES.encrypt(cryptoJS.enc.Utf8.parse(_cryptoModel.valueString), key, {
            keySize: _cryptoModel.keySize,
            iv: iv,
            mode: cryptoJS.mode.CBC,
            padding: cryptoJS.pad.Pkcs7
        });
          //Decrypt
        var bytes = cryptoJS.AES.decrypt(ciphertext.toString(), _cryptoModel.vEncVector);
        var plaintext = bytes.toString(cryptoJS.enc.Utf8);
        return encValue;
    }

   
}